import React, { useEffect, useState } from "react";
import GovernanceHero from "../governance/GovernanceHero";
import { Link, useLocation } from 'react-router-dom';

const ReturnAnnual = () => {
  const [companyEducomp, setCompanyEducomp] = useState([]);

  // fetch data
  useEffect(() => {
    fetch("/jsonfile/AnnualReturn.json")
      .then((res) => res.json())
      .then((data) => setCompanyEducomp(data))
      .catch((err) => console.error("Error loading data:", err));
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <GovernanceHero headingText={"Annual Return"} />

      {/* Body Section */}
      <div className="mx-auto max-w-7xl py-8 px-4">
        <h3 className="my-4 text-lg text-gray-700 font-bold">Company</h3>

        <ul className="space-y-3">
          {companyEducomp.length > 0 ? (
            companyEducomp.map((company) => (
              <li key={company.id}>
                <a
                  href={company.PDF}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {company.Title} :{" "}
                  <span className="underline underline-offset-2 text-[#2baf2b]">
                    Download
                  </span>
                </a>
              </li>
            ))
          ) : (
            <p className="text-gray-500">No records found.</p>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ReturnAnnual;
